import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from '@core/api';

export const employeesApi = createApi({
  reducerPath: 'employeesApi',
  baseQuery,
  tagTypes: ['Employees'],
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getEmployees: builder.query({
      query: () => '/api/v1/employees/',
      providesTags: ['Employees'],
    }),
    getEmployee: builder.query({
      query: (id) => `/api/v1/employees/${id}/`,
      providesTags: (result, error, id) => [{ type: 'Employees', id }],
    }),
    searchEmployees: builder.query({
      query: ({ q, offset = 0 }) => `/api/v1/employees/search/?q=${encodeURIComponent(q)}&offset=${offset}`,
    }),
    // Marlex ONE candidatures of a candidate (not discarded, most advanced first)
    getSalesforceCandidatures: builder.query({
      query: (sfId) => `/api/v1/employees/salesforce-candidatures/?sf_id=${encodeURIComponent(sfId)}`,
    }),
    syncFromSalesforce: builder.mutation({
      query: (sfId) => ({
        url: '/api/v1/employees/sync-from-erp/',
        method: 'POST',
        body: { sf_id: sfId },
      }),
      invalidatesTags: ['Employees'],
    }),
  }),
});

export const {
  useGetEmployeesQuery,
  useGetEmployeeQuery,
  useLazySearchEmployeesQuery,
  useGetSalesforceCandidaturesQuery,
  useSyncFromSalesforceMutation,
} = employeesApi;
